export const OrderStatusDefaultTextResources = {
  headline: 'Order Status',
  description: 'we guess you are looking for an order status, have you tried our order status page?',
  buttonLabel: 'open order status',
};
